// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"3eTY0":[function(require,module,exports) {
// Timer 2.0
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Main function to start the timer
parcelHelpers.export(exports, "startTimer", ()=>startTimer);
var _workoutGeneratorJs = require("./workoutGenerator.js");
var _uiJs = require("./ui.js");
var _workoutTimesJs = require("./workoutTimes.js");
var _endWorkoutJs = require("./endWorkout.js");
let todaysWorkout = (0, _workoutGeneratorJs.getTodaysWorkout)();
const COUNTDOWN_INITIAL_TIME = 10;
let EXERCISE_TIME = 5;
let BREAK_TIME = 5;
const BEEP_TIMES = [
    3,
    2,
    1
];
const PHASES = {
    getReady: {
        time: COUNTDOWN_INITIAL_TIME
    },
    exercise: {
        time: EXERCISE_TIME
    },
    break: {
        time: BREAK_TIME
    }
};
const workoutState = {
    currentExercise: 0,
    currentPhase: PHASES.getReady,
    animationFrameId: null,
    isPaused: false,
    remainingPhaseTime: 0,
    endTime: 0,
    beepIndex: 0
};
function startTimer() {
    console.log(`Exercise Time: ${EXERCISE_TIME}, Break Time: ${BREAK_TIME}`);
    workoutState.remainingPhaseTime = workoutState.currentPhase.time;
    workoutState.endTime = Date.now() + workoutState.remainingPhaseTime * 1000;
    updatePhaseTimes();
    // Fetch the workout again in case it has doubled.
    todaysWorkout = (0, _workoutGeneratorJs.getTodaysWorkout)();
    enablePauseResumeListeners();
    const nextPhaseText = getNextPhaseText();
    (0, _uiJs.updateUpNextText)(nextPhaseText);
    updateTimer();
    console.log("So far everything worked!");
}
// Main animation loop for updating the timer and handling phase transitions
function animate() {
    if (workoutState.isPaused) return;
    const now = Date.now();
    workoutState.remainingPhaseTime = Math.max(0, workoutState.endTime - now);
    const remainingSeconds = Math.ceil(workoutState.remainingPhaseTime / 1000);
    const percentage = (workoutState.currentPhase.time * 1000 - workoutState.remainingPhaseTime) / (workoutState.currentPhase.time * 1000) * 100;
    // Update the display based on the current phase
    if (workoutState.currentPhase === PHASES.getReady || workoutState.currentPhase === PHASES.break) (0, _uiJs.updateTimerDisplayCoral)(remainingSeconds, percentage);
    else if (workoutState.currentPhase === PHASES.exercise) (0, _uiJs.updateTimerDisplayYellow)(remainingSeconds, percentage);
    // Play beep sound at specific times
    if (workoutState.beepIndex < BEEP_TIMES.length && remainingSeconds === BEEP_TIMES[workoutState.beepIndex]) {
        (0, _uiJs.playBeepSound)();
        workoutState.beepIndex++;
    }
    // Check if phase time is up and transition or continue animation
    if (workoutState.remainingPhaseTime <= 0) {
        cancelAnimationFrame(workoutState.animationFrameId);
        transitionToNextPhase();
    } else workoutState.animationFrameId = requestAnimationFrame(animate);
}
// Starts or resumes the timer animation
function updateTimer() {
    if (!workoutState.isPaused) workoutState.endTime = Date.now() + workoutState.remainingPhaseTime * 1000;
    workoutState.animationFrameId = requestAnimationFrame(animate);
    console.log("updateTimer is called");
}
// Handles phase transitions and starts the appropriate phase
function transitionToNextPhase() {
    if (workoutState.currentPhase === PHASES.getReady) startExercise();
    else if (workoutState.currentPhase === PHASES.break) finishBreak();
    else if (workoutState.currentPhase === PHASES.exercise) finishExercise();
}
// Starts the exercise phase
function startExercise() {
    const exerciseName = todaysWorkout[workoutState.currentExercise].name;
    (0, _uiJs.setExerciseText)(exerciseName);
    (0, _uiJs.speakText)(exerciseName);
    workoutState.currentPhase = PHASES.exercise;
    workoutState.remainingPhaseTime = PHASES.exercise.time;
    workoutState.beepIndex = 0;
    const nextPhaseText = getNextPhaseText();
    (0, _uiJs.updateUpNextText)(nextPhaseText);
    updateTimer();
}
// Ends the exercise phase and starts a break or finishes the workout
function finishExercise() {
    if (workoutState.currentExercise < todaysWorkout.length - 1) startBreak();
    else finishWorkout();
}
// Starts the break phase
function startBreak() {
    (0, _uiJs.setExerciseText)("Break");
    (0, _uiJs.speakText)("Break");
    workoutState.currentPhase = PHASES.break;
    workoutState.remainingPhaseTime = PHASES.break.time;
    workoutState.beepIndex = 0;
    const nextPhaseText = getNextPhaseText();
    (0, _uiJs.updateUpNextText)(nextPhaseText);
    updateTimer();
}
// Ends the break phase and starts the next exercise
function finishBreak() {
    workoutState.currentExercise++;
    startExercise();
}
// Completes the workout and disables interactions
function finishWorkout() {
    (0, _uiJs.setExerciseText)("Workout Complete!");
    document.getElementById("countdown").style.display = "none";
    document.getElementById("up-next-text").style.display = "none";
    disablePauseResumeListeners();
    (0, _endWorkoutJs.onWorkoutComplete)();
}
// Returns the text for the next phase
function getNextPhaseText() {
    if (workoutState.currentPhase === PHASES.getReady) return `Up Next: ${todaysWorkout[workoutState.currentExercise].name}`;
    else if (workoutState.currentPhase === PHASES.exercise) {
        if (workoutState.currentExercise < todaysWorkout.length - 1) return "Up Next: Break";
        else return "Finish Strong!";
    } else if (workoutState.currentPhase === PHASES.break) {
        if (workoutState.currentExercise < todaysWorkout.length - 1) return `Up Next: ${todaysWorkout[workoutState.currentExercise + 1].name}`;
        else return null;
    }
    return "";
}
// Updates the phase times dynamically
function updatePhaseTimes() {
    let updatedPhaseObject = (0, _workoutTimesJs.getPhases)();
    PHASES.exercise.time = updatedPhaseObject.exercise.time;
    PHASES.break.time = updatedPhaseObject.break.time;
    console.log("Phase times should be updated now.");
}
// Enables pause/resume event listeners
function enablePauseResumeListeners() {
    document.getElementById("circle-container").addEventListener("click", togglePauseResume);
    document.addEventListener("keydown", pauseResumeOnSpace);
    console.log("Pause resume listeners should now be enabled");
}
// Disables pause/resume event listeners
function disablePauseResumeListeners() {
    document.getElementById("circle-container").removeEventListener("click", togglePauseResume);
    document.removeEventListener("keydown", pauseResumeOnSpace);
}
// Toggles pause/resume functionality for the timer
function togglePauseResume() {
    if (workoutState.isPaused) {
        workoutState.isPaused = false;
        workoutState.endTime = Date.now() + workoutState.remainingPhaseTime * 1000;
        updateTimer();
    } else {
        workoutState.remainingPhaseTime = (workoutState.endTime - Date.now()) / 1000;
        cancelAnimationFrame(workoutState.animationFrameId);
        workoutState.isPaused = true;
    }
}
// Handles space bar press to toggle pause/resume
function pauseResumeOnSpace(event) {
    if (event.code === "Space") {
        event.preventDefault();
        togglePauseResume();
    }
    console.log("pause resume on space ran");
}

},{"./workoutGenerator.js":"3p0gh","./ui.js":"4ZrZU","./workoutTimes.js":"4965e","./endWorkout.js":"lfAso","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}]},["3eTY0"], "3eTY0", "parcelRequire3809")

//# sourceMappingURL=index.34a76014.js.map
